import React from 'react';

function CalendarModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl">
        <div className="flex justify-between items-center p-3 sm:p-4 border-b">
          <h2 className="text-lg sm:text-xl font-semibold">Book a Demo</h2>
          <button
            onClick={onClose}
            className="text-gray-800 hover:text-gray-800 focus:outline-none"
          >
            <svg className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-2 sm:p-4">
          {/* Google Calendar Appointment Scheduling */}
          <iframe 
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2rJAylv05WxixK4W0Ho2iPDlXAtUBgGTlOvlItgYl7CB-NTwbogvKM4HcfA80Q0zyfTyOFb0eF?gv=true" 
            style={{ border: 0 }} 
            width="100%" 
            height="600" 
            frameBorder="0"
            title="Google Calendar Appointment Scheduling"
          />
        </div>
      </div>
    </div>
  );
}

export default CalendarModal;